<template>
  <div class="group flex items-center w-full h-full relative p-6 bg-gray-100">
    <canvas ref="canvasElement" class="w-full h-full"></canvas>
  </div>
</template>

<script>
import PCMPlayer from 'pcm-player';
import usePcvmVisualizer from '@/Composables/usePcmVisualizer';

export default {
  name: 'PulseVisualizer',
  data() {
    return {
      pcmPlayer: null,
      analyser: null,
      dataArray: null,
      pcmVisualizer: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      // Init pcm player
      this.pcmPlayer = new PCMPlayer({
        encoding: '16bitInt',
        channels: 2,
        sampleRate: 44100,
        flushingTime: 10,
      });
      this.pcmPlayer.volume(1);

      this.analyser = new AnalyserNode(this.pcmPlayer.audioCtx);
      this.analyser.fftSize = 32;
      this.pcmPlayer.gainNode.connect(this.analyser);
      const bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(bufferLength);

      // Init pulse visualiser
      this.pcmVisualizer = usePcvmVisualizer(this.$refs.canvasElement);
    });
  },

  methods: {
    feedPcmPlayer(signal) {
      if (!this.pcmPlayer) return;
      const floats = new Int16Array(signal);
      this.pcmPlayer.feed(floats);
      this.analyser.getByteFrequencyData(this.dataArray);
      if (this.pcmVisualizer) this.pcmVisualizer.processSignal(this.dataArray);
    },
  },
};
</script>
